// extracted by mini-css-extract-plugin
export default {"main":"daa-z"};